import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export const AnnouncementForBuilder = (): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <UIText1>Оставить отзыв не получится, но вы можете на них отвечать</UIText1>
    </div>
  );
};
